<template>
    <th>
        <a @click="$emit('setSort', list, sort_col)">
            <!-- wrap_label: kazde slowo naglowka w osobnym wierszu (waskie kolumny) -->
            <template v-for="(line, lineIndex) in labelLines"><br v-if="lineIndex > 0" :key="'line' + lineIndex">{{ line }}</template>
            <i v-if="list.sort_col === sort_col"
               class="fas"
               :class="{'fa-long-arrow-alt-down': list.sort_dir === 'asc', 'fa-long-arrow-alt-up': list.sort_dir === 'desc'}"></i>
        </a>
        <!-- kolumna z danymi w dwoch wierszach: drugi naglowek (i sortowanie) pod pierwszym -->
        <template v-if="label2">
            <br>
            <a @click="$emit('setSort', list, sort_col2)">
                {{ __(label2) }}
                <i v-if="list.sort_col === sort_col2"
                   class="fas"
                   :class="{'fa-long-arrow-alt-down': list.sort_dir === 'asc', 'fa-long-arrow-alt-up': list.sort_dir === 'desc'}"></i>
            </a>
        </template>
    </th>
</template>

<script>
export default {
    name: "SortableTableHeader",
    props: ['list_type', 'list_index', 'sort_col', 'label', 'list', 'sort_col2', 'label2', 'wrap_label'],
    computed: {
        labelLines: function () {
            const text = this.__(this.label);

            return this.wrap_label ? text.split(' ') : [text];
        }
    }
}
</script>

<style scoped>
a {
    color: #495966;
}
a:hover {
    color: #0056b3;
}
</style>
